<template>
  <div>
    <el-table :data="tableData" border style="width: 100%;margin-top: 3vh">
      <el-table-column label="序号" type="index" width="100"></el-table-column>
      <el-table-column label="项目名称"> </el-table-column>
      <el-table-column label="设备号"> </el-table-column>
      <el-table-column label="状态"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils//port'
import base from '../../untils/base'
export default {
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
    
  },
}
</script>

<style scoped>
</style>